import { isoToEpochSeconds } from '@trajectory/astro';
import { useMemo } from 'react';
import { playbackClock } from '@/lib/playbackClock';
import type { TelemetrySeries } from '@/lib/telemetry-series';
import { useMissionStore } from '@/stores/missionStore';
import { useTelemetryStore } from '@/stores/telemetryStore';

export function telemetryPlaybackEpoch(
  series: TelemetrySeries | null,
  fallbackEpoch: number,
  timeSeconds: number,
): number {
  return series && series.epoch.length > 0 ? series.epoch[0]! + timeSeconds : fallbackEpoch;
}

/**
 * Quick starts do not edit the open mission, so all moving scene bodies must
 * use the loaded telemetry's epoch rather than an unrelated mission date.
 */
export function useSceneEpochBase(): number {
  const launchAt = useMissionStore((state) => state.document?.launchAt);
  const status = useTelemetryStore((state) => state.status);
  const fallback = useMemo(
    () => (launchAt ? isoToEpochSeconds(launchAt) : isoToEpochSeconds(new Date().toISOString())),
    [launchAt],
  );
  if (status !== 'ready') return fallback;
  return telemetryPlaybackEpoch(useTelemetryStore.getState().series, fallback, 0);
}

export function currentSceneEpoch(fallbackEpoch: number): number {
  const telemetry = useTelemetryStore.getState();
  return telemetry.status === 'ready'
    ? telemetryPlaybackEpoch(telemetry.series, fallbackEpoch, playbackClock.time)
    : fallbackEpoch;
}
